import { api } from "..";

export const getPaymentDetails = async (token, obligationId) => {
  try {
    const { data } = await api({
      url: `/api/v1/admin/fundObligations/${obligationId}/payout`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return {
      data,
    };
  } catch (error) {
    return {
      error,
    };
  }
};
